import { render, staticRenderFns } from "./ShortVideo.vue?vue&type=template&id=a8e5aa9a&scoped=true"
import script from "./ShortVideo.vue?vue&type=script&lang=js"
export * from "./ShortVideo.vue?vue&type=script&lang=js"
import style0 from "./ShortVideo.vue?vue&type=style&index=0&id=a8e5aa9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e5aa9a",
  null
  
)

export default component.exports